import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { otRequestFormTourSteps } from "./otRequestFormTourSteps";
import { useOvertimeTour } from "./useOvertimeTour";

const TOUR_STORAGE_KEY = "hr-overtime-request-form-tour-completed";

type OTRequestFormTourProps = {
  run: boolean;
  onCallback: (data: { status?: string; type?: string; index?: number }) => void;
};

export function OTRequestFormTour({ run, onCallback }: OTRequestFormTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={otRequestFormTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useOTRequestFormTour() {
  return useOvertimeTour(TOUR_STORAGE_KEY);
}
